import { Badge, Td,  Tr } from "@chakra-ui/react";
import { CompanyLogsItemProps } from "./types";

const CompanyLogsItem = ({ data }: CompanyLogsItemProps) => {
    const validateEstatus = (status?: number) => {
        switch (status) {
            case 1:
                return 'Sincronizado'
            case 2:
                return 'Error'
            default:
                return;
        }
    }
    return (
        <Tr>
            <Td>{data?.claveOrigen}</Td>
            <Td>{data?.mensaje}</Td>
            <Td><Badge colorScheme={data?.estatus === 2 ? 'red' : 'green'}>{validateEstatus(data?.estatus)}</Badge></Td>
            <Td>{data?.contexto}</Td>
            <Td>{data?.fecha}</Td>
            <Td>{data?.hora}</Td>
        </Tr>
    )
}

export default CompanyLogsItem;